import CareerApplicationFilterForm from '../../../internal/career_applications/career_application_filter_form.js';

export default CareerApplicationFilterForm;
